export const ZONE_TYPE_OPTIONS = [
  { label: "Dropzones", value: "dropzone" },
  { label: "Service Areas", value: "cycling_area" },
  { label: "Maintenance Zones", value: "maintenance" },
]

export const ZONE_LABELS = {
  dropzone: "Dropzones",
  cycling_area: "Service Areas",
  maintenance: "Maintenance Zones",
}

export const ZONE_DESCRIPTIONS = {
  dropzone: "Rental sessions that end outside of a dropzone will trigger an alert.",
  cycling_area: "Cycling outside of a service area will trigger an alert.",
  maintenance:
    "Cycling inside a maintenance zone will automatically transit the bicycle to in maintenance state.",
}
